export function getTextProps(props) {
    var _a;
    if (props.lh15 === true)
        props.lh = '15';
    else if (props.lh20 === true)
        props.lh = '20';
    if (props.small)
        props.textSize = 'small';
    else if (props.xsmall)
        props.textSize = 'x-small';
    else if (props.xxsmall)
        props.textSize = 'xx-small';
    else if (props.normal)
        props.textSize = 'normal';
    else if (props.xnormal)
        props.textSize = 'x-normal';
    else if (props.xxnormal)
        props.textSize = 'xx-normal';
    else if (props.large)
        props.textSize = 'large';
    else if (props.xlarge)
        props.textSize = 'x-large';
    else if (props.xxlarge)
        props.textSize = 'xx-large';
    else if (props.semi)
        props.textSize = 'semi';
    else if (props.xsemi)
        props.textSize = 'x-semi';
    else if (props.xxsemi)
        props.textSize = 'xx-semi';
    if (props.bold)
        props.textWeight = '500';
    else if (props.light)
        props.textWeight = '300';
    if (props.textCenter)
        props.textAlign = 'center';
    else if (props.textLeft)
        props.textAlign = 'left';
    else if (props.textRight)
        props.textAlign = 'right';
    var classes = (_a = {
            'noselect': props.noSelect,
            'forceselect': props.select,
            'text-vertical-center': props.textVerticalCenter,
            'uppercase': props.uppercase,
            'lowercase': props.lowercase,
            'capitalcase': props.capitalcase,
            'text-ellipsis': props.ellipsis,
            'text-clip': props.clip,
            't-bold': props.bold
        },
        _a["fw-".concat(props.textWeight)] = typeof props.textWeight === 'string',
        _a["t-".concat(props.textSize)] = typeof props.textSize === 'string',
        _a["text-".concat(props.textAlign)] = typeof props.textAlign === 'string',
        _a["lh-".concat(props.lh)] = typeof props.lh === 'string' || typeof props.lh === 'number',
        _a);
    var styleToUse = {};
    if (typeof props.fontSize === 'string' || typeof props.fontSize === 'number')
        styleToUse.fontSize = props.fontSize;
    if (typeof props.lineHeight === 'number' || props.lineHeight)
        styleToUse.lineHeight = props.lineHeight;
    if (props.overflowWrap) {
        styleToUse.overflowWrap = props.overflowWrap;
    }
    ;
    if (props.letterSpacing === 'compressed')
        styleToUse.letterSpacing = '-0.025em';
    else if (props.letterSpacing === 'normal')
        styleToUse.letterSpacing = '0em';
    else if (props.letterSpacing === 'wide')
        styleToUse.letterSpacing = '0.025em';
    else if (props.letterSpacing === 'wider')
        styleToUse.letterSpacing = '0.05em';
    else if (typeof props.letterSpacing === 'number')
        styleToUse.letterSpacing = props.letterSpacing;
    return {
        classes: classes,
        props: {},
        styles: styleToUse,
        variables: {}
    };
}
